<template>
  <div class="inner t-center">
    <div class="t-title sm mb-l header">Dates</div>
    <div class="t-copy md light mb-m">
      <span v-html="label"></span>
    </div>
    <div class="ui-input-wrapper time-filter-datepicker">
      <label class="dropdown-dp t-left">
        <span class="date-label">Trip dates</span>
        <date-range-picker
          class="date-picker-base"
          opens="right"
          :locale-data="{firstDay: 1, format: 'dd-mmm-yyyy'}"
          :showDropdowns="true"
          v-model="range"
          @startSelection="onSelectionStart"
          @finishSelection="onSelectionFinish"
          @toggle="onToggle"
          :linkedCalendars="true"
          :ranges="false"
          :showWeekNumbers="false"
          :dateFormat="dateFormat"
          controlContainerClass="report-input-wrapper"
          ref="picker"
        >
          <template v-slot:input="picker" style="border: none; padding: 0">
            <span @click.prevent="" class="date-picker-input" type="text">{{ selectedDates(picker) }}</span>
          </template>
        </date-range-picker>
      </label>
    </div>
    <BaseBtn class="btn amex-primary" @click="onClose">Let's go</BaseBtn>
  </div>
</template>

<script>
import BaseBtn from '@common/button/button.vue';
import DateRangePicker from '@mobi-components/vue2-daterange-picker';
import '@mobi-components/vue2-daterange-picker/dist/vue2-daterange-picker.css';

import {timeFrameDefaultValue, getReadableDuration} from './time-filter.types';

export default {
  components: {
    BaseBtn,
    DateRangePicker,
  },
  name: 'TimeFilter',
  props: {
    caption: String,
    value: {
      type: Object,
      default: () => ({...timeFrameDefaultValue}),
    },
  },
  mounted() {
    this.from = this.value.from || null;
    this.to = this.value.to || null;
    this.range = {
      startDate: this.from ? new Date(this.from) : null,
      endDate: this.to ? new Date(this.to) : null,
    };
    this.$emit('change', this.value);
    this.$material.locale.dateFormat = 'MMM d, yyyy';
    this.active = true;
    this.stopClick = this.stopClick.bind(this);
    this.$nextTick(() => {
      this.$refs.picker.$el.addEventListener('click', this.stopClick);
    });
  },
  beforeDestroy() {
    this.$refs.picker.$el.removeEventListener('click', this.stopClick);
  },
  data() {
    return {
      from: timeFrameDefaultValue.from,
      to: timeFrameDefaultValue.to,
      start: null,
      end: null,
      range: {
        startDate: null,
        endDate: null,
      },
    };
  },
  computed: {
    label() {
      return (
        this.caption ||
        `Enter the dates of your trip so you can browse and book one-way or roundtrip flights, stays, and other things to do.`
      );
    },
  },
  methods: {
    stopClick(e) {
      e.stopPropagation();
      e.preventDefault();
    },
    onToggle(isOpen) {
      if (isOpen) {
        return;
      }
      this.onSelectionFinish(this.end);
    },
    onSelectionStart(date) {
      this.start = date;
      this.range = {
        startDate: date,
        endDate: this.range.endDate,
      };
    },
    onSelectionFinish(date) {
      this.end = date;
      this.from = (this.start && this.start.valueOf()) || this.value.from || timeFrameDefaultValue.from;
      this.to = (this.end && this.end.valueOf()) || this.value.to || timeFrameDefaultValue.to;
      this.range = {
        startDate: new Date(this.from),
        endDate: new Date(this.to),
      };
      if (this.from !== this.to) {
        this.$refs.picker.togglePicker(false);
        this.submitFilters();
      } else {
        this.$refs.picker.togglePicker(true);
        this.$refs.picker.dateClick(this.start);
      }
    },
    onClose() {
      this.$emit('close');
    },
    selectedDates(picker) {
      if (!this.from || !this.to) {
        return 'Please pick the dates';
      }
      if (picker.startDate && picker.endDate) {
        const {start, end} = this.swapDates(picker.startDate, picker.endDate);
        return getReadableDuration(start, end);
      }
      const {start, end} = this.swapDates(this.from, this.to);
      return getReadableDuration(start, end);
    },
    swapDates(start, end) {
      if (!start || !end) {
        return {start, end};
      }
      const less = new Date(Math.min(start.valueOf(), end.valueOf()));
      const more = new Date(Math.max(start.valueOf(), end.valueOf()));
      return {start: less, end: more};
    },
    submitFilters() {
      if (!this.from || !this.to) {
        return;
      }
      const {start, end} = this.swapDates(this.from, this.to);
      return this.$emit('change', {
        from: start,
        to: end,
      });
    },
    dateFormat(classes, date) {
      if (!classes.disabled) {
        classes.disabled = date.getTime() < new Date();
      }
      return classes;
    },
  },
};
</script>

<style scoped>
.date-picker-input {
  height: auto;
  line-height: 1;
  width: 100%;
  border: none;
  padding: 0;
  font-size: 18px;
  background: none;
  border: none;
  text-align: left;
  padding: 5px 0;
  cursor: pointer;
  display: inline-block;
}

/* .date-picker-input[disabled] {
  background: rgba(247, 247, 247, 0.7);
  color: #dadada;
} */

.date-picker-base {
  width: 100%;
  padding: 5px 10px 5px 22px;
  z-index: 1;
}

.report-input-wrapper {
  border: none;
  padding: 0;
}

.inner {
  display: flex;
  flex-direction: column;
}
.ui-input-wrapper {
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  padding-top: 20px;
  /* overflow: hidden; */
}

.flex-container {
  display: flex;

  border-radius: 20px;
}

.toggle-box {
  border-radius: 20px;
  padding-top: 23px;
  padding-left: 26px;
  padding-right: 26px;
  padding-bottom: 16px;
  margin: 7px;
}

.ui-input-wrapper {
  position: relative;
  /* display: grid; */
  gap: 1em;
  /* grid-template-areas: 'top top' 'a b'; */

  margin-left: -3px;
  --dropdown-border: none;
}

.full-row {
  grid-area: top;
}

.short-left {
  grid-area: a;
  background: #fff;
  border-radius: 20px;
  padding-left: 20px;
}

.short-right {
  grid-area: b;
  background: #fff;
  border-radius: 20px;

  padding-left: 20px;
}

.short-full-row {
  grid-area: top;
  background: #fff;
  border-radius: 20px;
  padding-left: 20px;
}
.from-dropdown {
  position: absolute;
  left: 10px;
  top: 10px;
}

.btn {
  margin-left: auto;
  appearance: none;
  border: none;
  background: none;
  cursor: pointer;
  margin: 15px auto 5px;
}

.btn.amex-primary {
  background: var(--btn-primary-color, hsl(214, 64%, 48%));
  border-radius: 10px;
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 118.14%;
  text-align: center;
  letter-spacing: -0.005em;

  color: #ffffff;
  padding: 12px 100px 10px;
}

.btn.amex-primary:hover {
  background: var(--btn-primary-color-active, hsl(214, 64%, 30%));
}

.spec-dates-contaner {
  display: flex;
}

.dropdown-dp {
  background-color: #f7f7f7;
  border-radius: 20px;
  position: relative;
  cursor: pointer;
  display: block;
  /* overflow: hidden; */
  /* pointer-events: none; */
}

.dropdown-dp input {
  background-color: rgba(0, 0, 0, 0);
}

.dropdown-dp:after {
  content: '';
  background-image: url("data:image/svg+xml,%3Csvg width='11' height='9' viewBox='0 0 11 9' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M5.5 9L0.73686 0.750001L10.2631 0.75L5.5 9Z' fill='%23071D3B'/%3E%3C/svg%3E%0A");
  background-repeat: no-repeat;
  position: absolute;
  right: 15px;
  top: 50%;
  width: 10px;
  height: 10px;
  transform: translateY(-5px);
  z-index: 1;
  pointer-events: none;
}

.dropdown-dp:before {
  content: '';
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: -10px;
  z-index: 1;
}

.dropdown-dp[disabled]:before {
  background: rgba(247, 247, 247, 0.7);
}

span.date-label {
  color: #a3abb6;
  font-size: 12px;
  position: relative;
  top: 7px;
  left: 22px;
}
</style>

<style>
.time-filter-datepicker .drp-buttons {
  display: none !important;
}
.time-filter-datepicker .md-icon {
  display: none;
}

.time-filter-datepicker .md-icon-button {
  display: none;
}

.time-filter-datepicker .md-field {
  --md-theme-default-primary: transparent;
  --md-theme-default-text-primary-on-background: transparent;
  --md-theme-default-primary: var(--primary-color, #2c70c9);
  margin: 1px 20px 5px 10px;
  min-height: 0;
  padding-top: 0;
}

.time-filter-datepicker .md-field:after,
.time-filter-datepicker .md-field:before {
  height: 0;
}

.time-filter-datepicker .md-field > .md-icon ~ label {
  left: 12px;
  color: #333;
  top: 6px;
}

.time-filter-datepicker .md-field.md-has-value label,
.time-filter-datepicker .md-field.md-focused label {
  opacity: 0;
}

/* .time-filter-datepicker-settings {
  --datepicker-overlay-bg: transparent;
  --datepicker-overlay-z: 12;
} */

.md-datepicker-overlay {
  background: transparent;
  z-index: 12;
}

.md-datepicker-dialog {
  z-index: 13;
}

.md-datepicker-header {
  display: none;
}

.md-datepicker-body-footer {
  display: none;
}
</style>
